// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"f711a130","204":"14cdf98d","245":"4e8184a8","259":"b42d859b","336":"e9a4221c","366":"830e4b58","445":"d7c90259","453":"d2701fb7","467":"e7a9adf2","487":"e6911cf5","489":"0e8fc52c","646":"e13994db","677":"52928173","876":"768c1204","920":"7b5379d9","921":"aba09fee"}[chunkId] + ".chunk.js";
};